import styled from 'styled-components'

import ActionButton from '../../components/ActionButton'
import TitleDescription from '../../components/TitleDescription'

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Heading = styled(TitleDescription)`
  text-align: center;
`

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
`

export const Cta = styled(ActionButton)``
